function prettifyEnumName(enumName) {
  if (!enumName) return "";
  let name = enumName.replace(/^CAIS/, "").replace(/^PublicInformation/, "");
  return name
    .replace(/([a-z])([A-Z0-9])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .trim();
}

export default prettifyEnumName;